module.exports = __webpack_public_path__ + "static/British_Land_logo_blue-eb3669b91a0040b1ea6fbaa3f979b26b.png";